import { Center, Image } from '@chakra-ui/react'
import React, { useState } from 'react'

const API_ORIGIN = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

function resolveImageSource(source) {
  if (!source || typeof source !== 'string') return '';
  if (source.startsWith('//')) return `https:${source}`;
  if (source.startsWith('http://')) return source.replace(/^http:/, 'https:');
  if (source.startsWith('/')) return `${API_ORIGIN}${source}`;
  return source;
}

export default function Card(props) {
  const [imageSource, setImageSource] = useState(resolveImageSource(props.src));

  if (!imageSource) return null;

  return (
    <>
     <Center
        w={"100%"}
        minH={{base:"220px",sm:"340px",md:"420px",xl:"470px"}}
      >
        <Center cursor={"pointer"}>
          <Image
            src={imageSource}
            onError={() => setImageSource('')}
            alt={props.alt || props.title || props.desc || 'Ajanta Cloth House product image'}
            title={props.title || props.alt || ''}
            loading={props.loading || 'lazy'}
            h={{base:"220px", sm: "340px",md:"420px",xl:"470px"}}
            w={{base:"150px",sm:"200px",md:"300px"}}
            borderRadius={20}
          />
        </Center>
      </Center>
    </>
  )
}
